import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import {
    Box,
    Button,
    Link,
    Flex,
    HStack,
    Menu,
    MenuButton,
    MenuDivider, MenuItem, MenuList,
    Text, Image
} from '@chakra-ui/react';
import DrawerSidebar from '../DrawerSidebar';
import BreadcrumbMp from "../BreadcrumbMp";
import logomca from "../../../img-docs/logomca.svg"
import { useAuth } from 'react-oidc-context';
import { FotoUsuario } from '../FotoUsuario';

const Navbar = (props) => {
    const auth = useAuth();

    const handleLogout = () => {
        auth.signoutRedirect();
    };

    const {
        categoria,
        pagina,
        entidade,
        entidadeHref,
        display
    } = props;

    return (
        <>
            <Box
                display={{ base: "none", md: display ? display : "block" }}
                px={7}
                w="100%"
                background="#DDEBEA"
                zIndex="overlay"
                h={["50px", "75px"]}
                data-testid="navbar"
            >
                <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>

                    <HStack spacing={8} alignItems={'center'}>
                        <BreadcrumbMp
                            categoria={categoria}
                            entidadeHref={entidadeHref}
                            pagina={pagina}
                            entidade={entidade}
                        />

                        <HStack
                            as={'nav'}
                            spacing={4}
                            display={{ base: 'none', md: 'flex' }}>
                        </HStack>
                    </HStack>

                    <Flex alignItems={'center'}>
                        <Menu>
                            <Text
                                variant={'solid'}
                                size={'sm'}
                                mr={4}>

                                {auth.user.profile?.name}
                            </Text>
                            <MenuButton
                                as={Button}
                                rounded={'full'}
                                variant={'link'}
                                cursor={'pointer'}
                                minW={0}>
                                <FotoUsuario />
                                {/* <Avatar
                                    size={'sm'}
                                    m={2}
                                    src={
                                        'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                                    }
                                /> */}
                            </MenuButton>
                            <MenuList>
                                <MenuItem>Perfil</MenuItem>
                                <MenuItem>Configurações</MenuItem>
                                <MenuDivider />
                                <MenuItem onClick={handleLogout}>Sair</MenuItem>
                            </MenuList>
                        </Menu>
                    </Flex>
                </Flex>

            </Box>

            <Box
                display={{ base: display ? display : "block", md: "none" }}
                px={7}
                w="100%"
                background="#1E6164"
                zIndex="overlay"
                h={["75px", "75px"]}
            >
                <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>

                    <Flex alignItems={'center'}>
                        <Link alignSelf="center"
                            as={ReactLink}
                            to={"/"}>
                            <Image w={120} src={logomca} role="img" />
                        </Link>
                    </Flex>

                    <HStack spacing={8} alignItems={'center'}>
                        <DrawerSidebar />


                        <HStack
                            as={'nav'}
                            spacing={4}
                            display={{ base: 'none', md: 'flex' }}>
                        </HStack>
                    </HStack>
                </Flex>

            </Box>

            <Flex
                display={{ base: display ? display : "block", md: "none" }}
                alignItems={'center'}
                m={"8px"}
            >
                <BreadcrumbMp categoria={categoria}
                    entidadeHref={entidadeHref}
                    pagina={pagina}
                    entidade={entidade} />
            </Flex>
        </>
    );
}

export default Navbar;